import { Controller } from "stimulus";
import readXlsxFile from "read-excel-file";

export default class extends Controller {
  static targets = [
    "input",
    "filename",
    "container",
    "attachments",
    "inputFileTrashButton",
    "clearButton",
    "submitButton",
    "importButton"
  ];

  connect() {
    this.selectedFiles = [];
  }

  getFileName() {
    if (this.inputTarget.files[0]) {
      this.filenameTarget.innerText = this.inputTarget.files[0].name;
      this.clearButtonTarget.classList.remove('is-hidden');
      this.importButtonTarget.removeAttribute('disabled');
    } else {
      this.filenameTarget.innerText = "Nenhum arquivo selecionado";
      this.importButtonTarget.setAttribute('disabled');
      this.removeTable();
    }
  }

  getAttachments() {
    const newFiles = Array.from(this.inputTarget.files);
    this.selectedFiles = this.selectedFiles.concat(newFiles);

    this.updateAttachmentsPreview();
    this.inputFileTrashButtonTarget.classList.remove('is-hidden');
    this.updateInputFiles();
  }

  updateAttachmentsPreview() {
    while (this.attachmentsTarget.firstChild) {
      this.attachmentsTarget.removeChild(this.attachmentsTarget.lastChild);
    }
    this.selectedFiles.forEach(file => this.appendPreview(file.name));
  }

  appendPreview(fileName) {
    var pathElement = document.createElement("p")
    pathElement.innerText = fileName
    this.attachmentsTarget.appendChild(pathElement)
  }

  removeAllAttachmentsPreview() {
    this.selectedFiles = [];
    this.inputTarget.value = "";
    this.updateAttachmentsPreview();
    this.inputFileTrashButtonTarget.classList.add('is-hidden');
    this.submitButtonTarget.setAttribute('disabled', 'true');
    this.updateInputFiles();
  }

  updateInputFiles() {
    const dataTransfer = new DataTransfer();
    this.selectedFiles.forEach(file => dataTransfer.items.add(file));
    this.inputTarget.files = dataTransfer.files;  
  }
  openXlsx() {
    if (this.selectedFiles.length > 0) {
      readXlsxFile(this.selectedFiles[0]).then((rows) => {
        this.createTable(rows);
      });
    }
  }

  parseXlsx() {
    if (this.selectedFiles.length > 0) {
      readXlsxFile(this.selectedFiles[0], { map, trim: false }).then(
        (rows) => console.log(rows)
      );
    }
  }

  removeTable() {
    this.containerTarget.previousElementSibling.remove();
    this.containerTarget.children[0].remove();
  }

  createTable(rows) {
    if (this.containerTarget.children[0]) this.removeTable();
    let title = document.createElement("h2");
    let table = document.createElement("table");

    title.classList.add("title", "is-5", "mt-3");
    table.classList.add(
      "table",
      "has-text-centered",
      "is-striped",
      "is-hoverable",
      "is-bordered",
      "is-size-7",
      "is-scrollable-y"
    );

    title.innerText = `Pré-visualização (${
      rows.length - 1
    } itens para importação)`;

    this.containerTarget.before(title);
    this.containerTarget.appendChild(table);

    rows.forEach((row, index) => {
      if (index == 0) {
        let thead = document.createElement("thead");
        table.appendChild(thead);
        let tr = document.createElement("tr");
        thead.appendChild(tr);

        row.forEach((cell) => {
          let th = document.createElement("th");
          th.innerText = cell;
          th.classList.add("is-narrow");
          tr.appendChild(th);
        });
      } else {
        let tbody = document.createElement("tbody");
        table.appendChild(tbody);
        let tr = document.createElement("tr");
        tbody.appendChild(tr);

        row.forEach((cell) => {
          let td = document.createElement("td");
          if (cell != null && cell.length > 100) {
            cell = cell.slice(0, 70) + "...";
          }
          if (cell != null && new Date(cell).getFullYear() > 2020) {
            cell = new Date(cell).toLocaleDateString()
          }
          td.innerText = cell;
          td.classList.add("is-narrow");
          tr.appendChild(td);
        });
      }
    });
  }

  toggleButton() {
    if (this.selectedFiles.length > 0) {
      this.submitButtonTarget.removeAttribute('disabled');
    } else {
      this.submitButtonTarget.setAttribute('disabled', 'disabled');
    }
  }
}
